import {
  DEFAULT_LOCALE,
  fieldSectionMap,
  isReviewerOnlyField,
  isReviewerOnlySection,
  labelOf,
  optionLine,
  optionValue,
  pageTitle,
} from './formBuilderModel'

function conditionMet(cond, answers) {
  if (!cond || !cond.fieldId) return true
  const v = answers[cond.fieldId]
  const empty = v === undefined || v === '' || (Array.isArray(v) && v.length === 0)
  if (cond.operator === 'is_empty') return empty
  if (cond.operator === 'is_not_empty') return !empty
  if (empty) return false
  if (cond.operator === 'equals') return Array.isArray(v) ? v.includes(cond.value) : String(v) === String(cond.value)
  if (cond.operator === 'not_equals') return Array.isArray(v) ? !v.includes(cond.value) : String(v) !== String(cond.value)
  return true
}

/** @typedef {'submitter' | 'review' | 'all'} FormFillRole */

export function shouldShowSection(section, fillRole, visibleSectionIds = null) {
  if (visibleSectionIds && !visibleSectionIds.includes(section.id)) return false
  if (fillRole === 'all') return true
  if (fillRole === 'submitter' && isReviewerOnlySection(section)) return false
  return true
}

export function shouldShowField(field, section, fillRole, visibleSectionIds = null) {
  if (visibleSectionIds && !visibleSectionIds.includes(section.id)) return false
  if (fillRole === 'all') return true
  const reviewerOnly = isReviewerOnlyField(field, section)
  if (fillRole === 'submitter' && reviewerOnly) return false
  return true
}

export function isFieldEditable(field, section, fillRole, closed) {
  if (closed) return false
  if (fillRole === 'submitter') return true
  if (fillRole === 'review') return isReviewerOnlyField(field, section)
  return false
}

export function visibleFormFields(definition, answers, fillRole = 'submitter', visibleSectionIds = null) {
  const sectionMap = fieldSectionMap(definition)
  const out = []
  for (const page of definition?.pages || []) {
    for (const section of page.sections || []) {
      if (!shouldShowSection(section, fillRole, visibleSectionIds)) continue
      if (section.condition && !conditionMet(section.condition, answers)) continue
      for (const field of section.fields || []) {
        if (!shouldShowField(field, section, fillRole, visibleSectionIds)) continue
        if (field.condition && !conditionMet(field.condition, answers)) continue
        out.push({ page, section, field })
      }
    }
  }
  return out
}

export { DEFAULT_LOCALE, labelOf, optionLine, optionValue, pageTitle, isReviewerOnlyField, isReviewerOnlySection }
